import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { ApplicationContext } from "../../context/application_ctx";
import {
  IconButtonMA,
  LinearProgressMA,
} from "../../styles/styledComponents";
import { Close } from "@mui/icons-material";
import { ButtonCustom } from "../button";
import { font } from "../../styles/font";
import { theme } from "../../styles/theme";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";

export default function UploadConfirmation({
  setOpenUploadConfirm,
  openUploadConfirm,
  setTouchUpload,
  licenceCount,
  limit,
  uploadLength,
}) {
  // context
  const navigate = useNavigate()
  console.log(uploadLength, "limit");
  const { setActiveTab } = useContext(ApplicationContext);

  function handleCloseRegisterDialog() {
    setOpenUploadConfirm(false);
  }

  const handleUpgrade = () => {
    setOpenUploadConfirm(false);
    setActiveTab(2);
    navigate('/licence')
  };

  return (
    <Dialog
      onClose={handleCloseRegisterDialog}
      open={openUploadConfirm}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "35%",
          //  minHeight: "60vh"
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" color={theme.col_3}>
            Upload Employees
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <IconButtonMA size="small" onClick={handleCloseRegisterDialog}>
              <Close />
            </IconButtonMA>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 1.5 }}>
        <Box
          py={0.8}
          px={1}
          display="flex"
          flexDirection="column"
          gap={2}
          alignItems="center"
        >
          {limit?.totalLicence === limit?.allocatedLicence ? (
            <Typography variant="h6" color={theme.col_2} textAlign="center">
              Your licence limit reached please upgrade
            </Typography>
          ) : (
            <>
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="h6"
                  display="flex"
                  gap="4px"
                  color={theme.col_2}
                  textAlign="center"
                >
                  Upload requested:{" "}
                  <Typography
                    variant="h6"
                    color={theme.col_3}
                    textAlign="center"
                  >
                    {uploadLength}
                  </Typography>
                </Typography>
                <Typography
                  variant="h6"
                  display="flex"
                  gap="4px"
                  color={theme.col_2}
                  textAlign="center"
                >
                  Avaliable licence:{" "}
                  <Typography
                    variant="h6"
                    color={theme.col_3}
                    textAlign="center"
                  >
                    {licenceCount}
                  </Typography>
                </Typography>
                <Typography
                  variant="h6"
                  display="flex"
                  gap="4px"
                  color={theme.col_2}
                  textAlign="center"
                >
                  One time upload limit:{" "}
                  <Typography
                    variant="h6"
                    color={theme.col_3}
                    textAlign="center"
                  >
                    1000
                  </Typography>
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="h6"
                  display="flex"
                  gap="4px"
                  color={theme.col_2}
                  textAlign="center"
                >
                  {uploadLength > 1000 ? 'You are trying to upload more than 1000 employess which is exceeding one time upload limit!'  : "To upload more then avaliable licences please upgrade"}
                </Typography>
              </Box>
            </>
          )}
          <Box
            py={0.8}
            px={1}
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap={2}
          >
            {limit?.totalLicence === limit?.allocatedLicence || uploadLength > 1000 ? (
              <></>
            ) : (
                <>
              <ButtonCustom
                onClick={() => setTouchUpload(true)}
                fullWidth={false}
                width="90px"
                // disabled={loaderStateApi}
                // loaderState={loaderStateApi}
                borderRadius="42px"
                size="large"
                background={theme.col_3_alpha}
                backgroundRipple={theme.col_3_alpha}
                focusColor={theme.col_1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_4}
                    fontWeight="bold"
                    color={theme.col_3}
                  >
                    Confirm
                  </Typography>
                }
              />
            <ButtonCustom
              onClick={handleUpgrade}
              fullWidth={false}
              width="90px"
              // disabled={loaderStateApi}
              // loaderState={loaderStateApi}
              borderRadius="42px"
              size="large"
              background={theme.col_2_alpha}
              backgroundRipple={theme.col_2_alpha}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_4}
                  fontWeight="bold"
                  color={theme.col_2}
                >
                  Upgrade
                </Typography>
              }
            />
                </>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export function UploadProgress({
  uploadLength,
  uploadProgress,
}) {
  // context
  console.log(uploadLength, "limit");

  // function handleCloseRegisterDialog() {
  //   setOpenUploadConfirm(false);
  // }

  // const handleUpgrade = () => {
  //   setOpenUploadConfirm(false);
  //   setActiveTab(2);
  // };

  return (
    <Dialog
      // onClose={handleCloseRegisterDialog}
      open={uploadProgress}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "35%",
          //  minHeight: "60vh"
        },
      }}
    >
      <DialogTitle>
        {/* <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" color={theme.col_3}>
              Upload Employees
            </Typography>
  
            <Box display="flex" alignItems="center" gap={2}>
              <IconButtonMA size="small" onClick={handleCloseRegisterDialog}>
                <Close />
              </IconButtonMA>
            </Box>
          </Box> */}
      </DialogTitle>
      <DialogContent sx={{ px: 1.5 }}>
        <Box
          py={0.8}
          px={1}
          display="flex"
          flexDirection="column"
          gap={2}
          alignItems="center"
        >
          <FileUploadIcon sx={{ color: theme.col_2, fontSize: "126px" }} />
          <LinearProgressMA
            sx={{
              width: "80%",
              ".MuiLinearProgress-bar": { background: theme.col_2 },
              background: theme.col_2_alpha2,
            }}
          />
          <Typography variant="h6" color={theme.col_2} textAlign="center">
            Uploading Please Wait....
          </Typography>
          {/* <Box
              py={0.8}
              px={1}
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={2}
            >
              {limit?.totalLicence === limit?.allocatedLicence ? <></> :<ButtonCustom
                onClick={() => setTouchUpload(true)}
                fullWidth={false}
                width="90px"
                // disabled={loaderStateApi}
                // loaderState={loaderStateApi}
                borderRadius="42px"
                size="large"
                background={theme.col_3_alpha}
                backgroundRipple={theme.col_3_alpha}
                focusColor={theme.col_1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_4}
                    fontWeight="bold"
                    color={theme.col_3}
                  >
                    Confirm
                  </Typography>
                }
              />}
              <ButtonCustom
                onClick={handleUpgrade}
                fullWidth={false}
                width="90px"
                // disabled={loaderStateApi}
                // loaderState={loaderStateApi}
                borderRadius="42px"
                size="large"
                background={theme.col_2_alpha}
                backgroundRipple={theme.col_2_alpha}
                focusColor={theme.col_1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_4}
                    fontWeight="bold"
                    color={theme.col_2}
                  >
                    Upgrade
                  </Typography>
                }
              />
            </Box> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
